/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CreateCustomerTankRequest from './CreateCustomerTankRequest';

/**
* The CreateCustomerRequest model module.
* @module model/CreateCustomerRequest
* @version 2020-12-7
*/
export default class CreateCustomerRequest {
    /**
    * Constructs a new <code>CreateCustomerRequest</code>.
    * 顧客登録リクエスト
    * @alias module:model/CreateCustomerRequest
    * @class
    * @param code {String} 
    * @param name {String} 
    * @param groupId {Number} 
    * @param deliveryGroupId {Number} 
    * @param address {String} 
    * @param tel {String} 
    * @param remarks {String} 
    * @param tanks {Array.<module:model/CreateCustomerTankRequest>} 
    */

    constructor(code, name, groupId, deliveryGroupId, address, tel, remarks, tanks) {
        
        
        this['code'] = code;
        this['name'] = name;
        this['groupId'] = groupId;
        this['deliveryGroupId'] = deliveryGroupId;
        this['address'] = address;
        this['tel'] = tel;
        this['remarks'] = remarks;
        this['tanks'] = tanks;
        
    }

    /**
    * Constructs a <code>CreateCustomerRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerRequest} obj Optional instance to populate.
    * @return {module:model/CreateCustomerRequest} The populated <code>CreateCustomerRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerRequest();
                        
            
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('tanks')) {
                obj['tanks'] = ApiClient.convertToType(data['tanks'], [CreateCustomerTankRequest]);
            }
        }
        return obj;
    }

    /**
    * @member {String} code
    */
    'code' = undefined;
    /**
    * @member {String} name
    */
    'name' = undefined;
    /**
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * @member {String} address
    */
    'address' = undefined;
    /**
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * @member {Array.<module:model/CreateCustomerTankRequest>} tanks
    */
    'tanks' = undefined;




}
